export class GeneralCellRenderer {
    public params: any = null;
}
